import parentTestActions from '../actions/ParentTestActions';

function approveDescriptionDoc(body, state) {
    const newState = JSON.parse(JSON.stringify(state));
    newState.childTests = state.childTests.map((childTest) => {
        if (childTest.assessmentRunId === body) {
            childTest.descriptionDocumentApproved = true;
            return childTest;
        }
        return childTest;
    });
    return newState;
}

function deliverChildTestOffline(body, state) {
    const newState = JSON.parse(JSON.stringify(state));
    newState.childTests = state.childTests.map((childTest) => {
        if (childTest.assessmentRunId === body) {
            childTest.deliveredOffline = true;
            return childTest;
        }
        return childTest;
    });
    return newState;
}

function setChildTestStartedOffline(assessmentRunId, state) {
    const newState = JSON.parse(JSON.stringify(state));
    newState.childTests = state.childTests.map((childTest) => {
        if (childTest.assessmentRunId === assessmentRunId) {
            childTest.startedOffline = true;
            return childTest;
        }
        return childTest;
    });
    return newState;
}

function setChildTestHasPlayedDescriptionMedia(state, assessmentRunId, hasCompletelyPlayedMedia) {
    const newState = JSON.parse(JSON.stringify(state));
    const test = newState.childTests.find(childTest => childTest.assessmentRunId === assessmentRunId);
    if (test) {
        test.hasAtLeastOneCompletelyPlayedMedia = hasCompletelyPlayedMedia;
    }

    return newState;
}

export default function (state = {}, action) {
    switch (action.type) {
    case parentTestActions.types.CHILD_TESTS_LOAD_SUCCESS:
        return Object.assign({}, state, action.body);

    case parentTestActions.types.CHILD_TESTS_LOAD_FAILED:
        return Object.assign({}, state, action.body);

    case parentTestActions.types.DESCRIPTION_DOC_CONFIRMED:
        return Object.assign({}, state, approveDescriptionDoc(action.body, state));

    case parentTestActions.types.DELIVER_TEST_OFFLINE:
        return Object.assign({}, state, deliverChildTestOffline(action.body, state));

    case parentTestActions.types.SET_TEST_STARTED_OFFLINE:
        return Object.assign({}, state, setChildTestStartedOffline(action.assessmentRunId, state));

    case parentTestActions.types.SET_CHILD_TEST_HAS_COMPLETELY_PLAYED_DESCRIPTION_MEDIA:
        return Object.assign({}, state, setChildTestHasPlayedDescriptionMedia(state, action.assessmentRunId, action.hasCompletelyPlayedMedia));

    case parentTestActions.types.SET_PARENT_TEST_QUESTION_SET:
        return Object.assign({}, state, {
            assessment: action.body,
        });

    case parentTestActions.types.UPDATE_MINUTES_UNTIL_START_TIME:
        return Object.assign({}, state, {
            minutesUntilChildStartTime: action.body,
        });

    default:
        return state;
    }
}
